/**
 * getOwnerPlan.ts — fetch tour-owner plan via check-subscription-for-project.
 */
import { BaseXHR } from '@utils/axios';
import { I_OwnerPlan, T_OwnerPlan } from '../types/I_OwnerPlan';

const OWNER_PLAN_ENDPOINT = '/project/check-subscription-for-project';

interface GetOwnerPlanParams {
  slug: string;
}

const resolveViewerPlan = (userPlan: string): T_OwnerPlan => {
  const normalized = userPlan.trim().toLowerCase();
  if (normalized === 'free trial') return 'paid';
  if (normalized === 'free') return 'free';
  return 'paid';
};

const normalizeOwnerPlan = (payload: any): I_OwnerPlan => {
  const userPlan = payload?.userPlan || payload?.plan || '';
  return {
    plan: resolveViewerPlan(userPlan),
    userPlan,
    subscriptionStatus: payload?.subscriptionStatus || '',
    subscriptionType: payload?.subscriptionType || '',
  };
};

export const getOwnerPlan = async ({
  slug,
}: GetOwnerPlanParams): Promise<I_OwnerPlan> => {
  if (!slug) throw new Error('Missing project slug');

  const { data } = await BaseXHR.$get(OWNER_PLAN_ENDPOINT, { slug });
  return normalizeOwnerPlan(data?.data || data);
};

export const getPublicTourUrl = (
  slug?: string,
  scene?: string | string[],
): string => {
  const base = (process.env.NEXT_PUBLIC_BASE_URL || '').replace(/\/$/, '');
  if (!base || !slug) return '';
  const sceneSlug = Array.isArray(scene) ? scene[0] : scene;
  return sceneSlug ? `${base}/${slug}/${sceneSlug}` : `${base}/${slug}`;
};
